"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginContainer = void 0;
const react_1 = __importDefault(require("react"));
const fds_1 = require("@tcc/fds");
const styles = __importStar(require("./pluginContainer.css"));
const PluginContainer = ({ children, levels = [], orientation = [], testId = 'plugin-container', }) => (react_1.default.createElement("div", { className: styles.pluginContainerWrapper }, levels === null || levels === void 0 ? void 0 :
    levels.slice(0, 3).map((level, index) => {
        const hasContainer = level.some((element) => react_1.default.isValidElement(element) && element.type === fds_1.Container);
        return (react_1.default.createElement(react_1.default.Fragment, { key: index },
            hasContainer ? (level) : (react_1.default.createElement(fds_1.Container, { border: false, padding: {
                    top: fds_1.ComponentPadding.Container,
                    right: fds_1.ComponentPadding.Container,
                    bottom: fds_1.ComponentPadding.Container,
                    left: fds_1.ComponentPadding.Container
                }, orientation: orientation[index], testId: `${testId}-level-${index}` }, level)),
            react_1.default.createElement(fds_1.Divider, null)));
    }),
    react_1.default.createElement("div", { className: styles.pluginWrapper }, children)));
exports.PluginContainer = PluginContainer;
